import TyEmpty from './TyEmpty.vue'
export default TyEmpty



// WEBPACK FOOTER //
// ./src/components/ty-empty/index.js